import { Outlet } from 'react-router-dom';
import { WikiSidebar } from '../components/wiki/WikiSidebar.js';
import { AppHeader } from '../components/AppHeader.js';
import '../styles/wiki.css';

export function WikiShell(): JSX.Element {
  return (
    <div className="wiki-shell">
      <AppHeader />
      <WikiSidebar />
      <main className="wiki-content">
        <Outlet />
      </main>
    </div>
  );
}
